import React from "react";
import { Modal } from "react-bootstrap";


import NumberFormat from "react-number-format";
import cookie from 'react-cookies';

import { getCarPrice } from "../../../model/car";

import { commonErr } from "../../common/errors";
import {  DType, getAddressName, isEqualObj, stypes } from "../../common/common";
import { LoadingOverlay } from "../../common/loading";
import { MessageLine } from "../../common/messagebox";

import { IcAddressType, IcListCar, IcPlane, IcLocationLine, IcUser, IcCloseOrange} from "../../common/svg";

import { mapSdk } from "../../../model/base";
import HereAutoComplete from "../../common/hereautocomplete";
import { initMap } from "../../common/wdfunction";


class MapDelivery extends React.Component {
		constructor(props) {
			super(props);
			this.state = {
				// markerArr: [],
				// directionsService: null,
				// directionsRenderer: null,
			}
			this.mapDelivery = React.createRef()

			
		}
	componentDidMount() {
		const { carAddress, dAddress } = this.props; 
		this.initMap(this.mapDelivery, [carAddress.location, dAddress.location]);	
	}
	
	componentDidUpdate(prevProps) {
		if (prevProps.dAddress.location !== this.props.dAddress.location) {
			this.initMap(this.mapDelivery, [this.props.carAddress.location, this.props.dAddress.location]);
		}
	}
		
		initMap = (refs, locAddress) =>{
			if (mapSdk != 0) {
				setTimeout(() => {
					initMap(true, this.mapDelivery, locAddress, false, 'deli-map');
				}, 1000)
				return;
			}
		}

  	render() {	
		return <div ref={this.mapDelivery} id="deli-map" className="wrap-map"></div>
	}
}



class MapLocation extends React.Component {

	constructor(props) {
		super(props)

		this.mapWD = React.createRef()
		this.mapSD = React.createRef()

	}
    componentDidMount() {
		if (this.props.stype == stypes.SD) {
			this.initMap(this.refs, this.props.location.lat, this.props.location.lng);
		} else {
			this.initMap(undefined, this.props.location.lat, this.props.location.lng);
		}
	

	}

	componentDidUpdate(prevProps) {
		if (prevProps.location.lat != this.props.location.lat || prevProps.location.lng != this.props.location.lng) {
			if (this.props.stype == stypes.SD) {
				this.initMap(this.mapSD, this.props.location.lat, this.props.location.lng);
			} else {
				this.initMap(undefined, this.props.location.lat, this.props.location.lng);
			}
		}
	}

    updateMarker = (map, position) => {
        this.pMarker.setMap(null);
        this.pMarker = new window.google.maps.Marker({
            position: position,
            map: map
        });
    }

    initMap = (refs, lat, lng) => {
		if (mapSdk != 0) {
			if (this.props.stype === stypes.SD) {
				setTimeout(() => {
					initMap(true, this.mapSD,  [{lat: lat, lng: lng}], false, 'deli-map');
				}, 1000)
			} else {
				setTimeout(() => {
					initMap(true, this.mapWD, [{lat: lat, lng: lng}], false, 'map-deli', stypes.WD);
				}, 1000)
			}
		
			return;
		}
        // const map = this.map = new window.google.maps.Map(refs.map, {
        //     center: {
        //         lat: lat,
        //         lng: lng
        //     },
        //     zoom: 17,
        //     mapTypeControl: false,
        //     scrollwheel: false,
        //     clickableIcons: false,
        //     streetViewControl: false,
        //     zoomControl: true,
        //     zoomControlOptions: {
        //         position: window.google.maps.ControlPosition.RIGHT_BOTTOM
        //     }
        // })

        // this.pMarker = new window.google.maps.Marker({
        //     position: new window.google.maps.LatLng(this.props.location.lat, this.props.location.lng),
        //     map: map
        // });

        // map.addListener('click', e => {
        //     this.props.onMarkerUpdate({
        //         lat: e.latLng.lat(),
        //         lng: e.latLng.lng()
        //     });
        // });

        // map.addListener('drag', () => {
        //     this.pMarker.setPosition(map.getCenter());
        // });

        // map.addListener('dragend', () => {
        //     const center = map.getCenter();
		// 			this.props.onMarkerUpdate({
		// 				lat: center.lat(),
		// 				lng: center.lng()
		// 			});
        // });
    }

    render() {
        return <div ref={this.props.stype == stypes.SD ? this.mapSD : this.mapWD} id="deli-map" className="wrap-map"></div>
    }
}

class CustomAddress extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			address: props.address,
			location: props.location,
			addressPlaceHolder: "Nhập chi tiết địa chỉ của bạn",
		}

	
	}

	onMarkerUpdate = (location) => {
		this.setState({
				location: location
		});
	}		

	onAddressChange = (address) => {
      
		if (!address || address === "") {
			this.setState({
				 location: null 
			});
		}
		
		this.setState({
			 address 
		});
	}


		onAddressUpdateError = (error) => {
				this.setState({
						address: "",
						addressPlaceHolder: "Không tìm thấy địa chỉ"
				});
		}

		onAddressFocus = () => {
		}

		onAddressRemove = () => {
				this.setState({
					address: "",
					location: null
				});
		}

		onAddressSelected = (address) => {
				if (address.err < 0) {
						var errMsg = "";
						if (address.err === -200) {
								errMsg = "Bạn đã không cho phép trình duyệt truy cập vị trí hiện tại. Vui lòng cài đặt cho phép hoặc nhập địa chỉ.";
						} else {
								errMsg = "Không thể tìm thấy vị trí hiện tại của thiết bị. Vui lòng thử lại hoặc nhập địa chỉ.";
						}
						this.setState({
								err: commonErr.FAIL,
								errMsg: errMsg
						});
				} else if (address.err === commonErr.LOADING) {
						this.setState({
								err: commonErr.LOADING,
								errMsg: ""
						});
				} else {
						this.setState({
								err: commonErr.LOADING,
								errMsg: ""
						});
						if (mapSdk == 0) {
							// geocodeByAddress(address.address)
							// 	.then(results => getLatLng(results[0]))
							// 	.then(latLng => {
							// 		this.setState({
							// 					address: address.address,
							// 					location: {
							// 							lat: latLng.lat,
							// 							lng: latLng.lng
							// 						},
							// 					err: commonErr.SUCCESS,
							// 					errMsg: ""
							// 			});
							// 	})
						} else {
							this.setState({
								address: address.address,
								location: {
										lat: address.lat,
										lng: address.lng
									},
								err: commonErr.SUCCESS,
								errMsg: ""
							})
						}
				}
		}
		
	isValidAddress = () => {
			const { location } = this.state
			return location && location.lat && location.lat !== 0 && location.lng && location.lng !== 0;
		}


	onUpdate = (address, location) => {
		this.props.onUpdate(address, location);
		this.close()
	}

	close = () => {
		this.props.onHide()
	}

	render() {
		const { err, errMsg, address, location, addressPlaceHolder } = this.state;

		return (
			<Modal
			show={this.props.show}
			onHide={this.close}
			dialogClassName="modal-s modal-dialog modal-input">
			<Modal.Header closeButton={true} closeLabel={""}>
				<h5>Địa điểm giao nhận xe</h5>
			</Modal.Header>
			<Modal.Body>
			<div className="modal-input-body modal-address">
				<div className="choose">
				<div className="choose-item">
					<HereAutoComplete
						inputProps={{
							value: address,
							onChange: this.onAddressChange,
							onFocus: this.onAddressFocus,
							placeholder: (this.state.address && this.state.address != "" ? this.state.address : "Nhập thành phố, quận, địa chỉ...")
						}}
						locAdrress={location}
						onSelect={(address) => this.onAddressSelected(address)} />
					<div className="wrap-svg" onClick={this.onAddressRemove}>
						<IcCloseOrange />
					</div>
				</div>
				<div className="space" />
				{err === commonErr.LOADING && <LoadingOverlay />}
				{err <= commonErr.FAIL && <MessageLine error={err} message={errMsg} />}
				{this.isValidAddress() === true &&
					<MapLocation
						stype={this.props.stype}
						address={address}
						location={location}
						onMarkerUpdate={this.onMarkerUpdate}
						onAddressUpdateError={this.onAddressUpdateError} />
				}
				</div>
				{/* <div id="map-block" style={{width: '100%', height: '250px', background: '#f6f6f6'}} /> */}
				<div className="wrap-btn has-2-btn">
					<a className="btn btn--m btn-primary" disabled={!address || !this.isValidAddress()} onClick={() => this.onUpdate(address, location)}>Áp dụng</a>
					<a className="btn btn-link" onClick={this.close}>Hủy bỏ</a>
				</div>
			</div>
			</Modal.Body>
		</Modal>
		)
	} 
}

// class CustomAddress extends React.Component {
// 	constructor(props) {
// 		super(props)
// 		this.state = {
// 			err: commonErr.INNIT,
// 			errMsg: "",
// 			address: props.address,
// 			location: props.location,
// 			addressPlaceHolder: "Nhập chi tiết địa chỉ của bạn",
// 		}
	
// 	}

// 	onMarkerUpdate = (location) => {
// 		this.setState({
// 				location: location
// 		});
// 	}		

// 	onAddressChange = (address) => {
      
// 		if (!address || address === "") {
// 			this.setState({
// 				 location: null 
// 			});
// 		}
		
// 		this.setState({
// 			 address 
// 		});
// 	}


// 		onAddressUpdateError = (error) => {
// 				this.setState({
// 						address: "",
// 						addressPlaceHolder: "Không tìm thấy địa chỉ"
// 				});
// 		}
// 		onAddressFocus = () => {

// 		}

// 		onAddressRemove = () => {
// 				this.setState({
// 					address: "",
// 					location: null
// 				});
// 		}

// 		onAddressSelected = (address) => {
// 				if (address.err < 0) {
// 						var errMsg = "";
// 						if (address.err === -200) {
// 								errMsg = "Bạn đã không cho phép trình duyệt truy cập vị trí hiện tại. Vui lòng cài đặt cho phép hoặc nhập địa chỉ.";
// 						} else {
// 								errMsg = "Không thể tìm thấy vị trí hiện tại của thiết bị. Vui lòng thử lại hoặc nhập địa chỉ.";
// 						}
// 						this.setState({
// 								err: commonErr.FAIL,
// 								errMsg: errMsg
// 						});
// 				} else if (address.err === commonErr.LOADING) {
// 						this.setState({
// 								err: commonErr.LOADING,
// 								errMsg: ""
// 						});
// 				} else {
// 						this.setState({
// 								err: commonErr.LOADING,
// 								errMsg: ""
// 						});
						
// 						this.setState({
// 							address: address.address,
// 							location: {
// 									lat: address.lat,
// 									lng: address.lng
// 								},
// 							err: commonErr.SUCCESS,
// 							errMsg: ""
// 						})
						
// 				}

// 				this.onUpdate(address, {lat: address.lat, lng: address.lng})
// 		}
		
// 	isValidAddress = () => {
// 			const { location } = this.state
// 			return location && location.lat && location.lat !== 0 && location.lng && location.lng !== 0;
// 		}


// 	onUpdate = (address, location) => {
// 		this.props.onUpdate(address.address, location);
// 		// this.close()
// 	}

// 	close = () => {
// 		this.props.onHide()
// 	}

// 	render() {
// 		const { address, location, addressPlaceHolder } = this.state;
// 		const { deliveryFee, deliveryDistance, dAddress, msgCustom } = this.props;


// 		return ( <div className="label-container" style={{width: '100%'}}> 
// 					<div className="address input">
// 						<div className="wrap-svg">
// 							<IcLocationLine />
// 						</div>
// 						<HereAutoComplete
					
// 							inputProps={{
// 								value: address,
// 								onChange: this.onAddressChange,
// 								onFocus: this.onAddressFocus,
// 								placeholder: (this.state.address && this.state.address != "" ? this.state.address : "Nhập thành phố, quận, địa chỉ...")
// 							}}
// 							locAdrress={location}
// 						onSelect={(address) => this.onAddressSelected(address)} />
						
// 					</div>
// 					{msgCustom !== '' && <p className="note text-danger">{msgCustom}</p>}
// 					{dAddress == address && <>
// 						{deliveryFee > 0 ? 
// 							<p className="note text-success">Tổng phí giao nhận xe (2 chiều) là <NumberFormat value={deliveryFee} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={' đ'} /> cho quãng đường {deliveryDistance} km</p> 
// 							: 
// 							deliveryFee == 0 ? 
// 							<p className="note text-success">Tổng phí giao nhận xe (2 chiều) là <NumberFormat value={deliveryFee} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={' đ'} /> cho quãng đường {deliveryDistance} km</p> 
// 							: 
// 							<p className="note text-danger">Địa điểm giao nhận quá xa so với vị trí của xe ({deliveryDistance} km). Bạn vui lòng chọn địa điểm giao nhận gần hơn hoặc có thể chọn thuê xe khác.</p>
// 						} 
// 					</>}
					
// 				</div>
		
		
// 		)
// 	} 
// }

class ListAddress extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			activeAddress: props.activeAddress.address
		}
	}
 
	componentDidUpdate(prevProps) {
		if (prevProps.activeAddress !== this.props.activeAddress) {
			this.setState({
				activeAddress: this.props.activeAddress.address
			})
		}
	}

	onSelectMyAddress = (addr) => {
		let addressName = `${addr.street}, ${addr.wardName}, ${addr.districtName}, ${addr.cityName}, ${addr.countryName}`;
		const address = {
			address: addressName,
			location: {
				lat: addr.lat,
				lon: addr.lon
			}
		}

		this.setState({
			activeAddress: addressName
		})

		this.props.onSelectMyAddress(address)
	}

	close = () => {
		this.props.onHide()
	}

	render() {
		const { activeAddress } = this.state;
		const { listAddress, show} = this.props;


		return ( 
			<Modal
			show={show}
			onHide={this.close}
			dialogClassName="modal-m modal-my-address">
			<Modal.Header closeButton={true} closeLabel={""}>
					<h5>Địa chỉ của tôi</h5>
			</Modal.Header>
			<Modal.Body>
			<div className="my-address">
			{listAddress && listAddress.map(addr => 
				<div className={`my-address__item ${activeAddress === getAddressName(addr) ? 'active' : ''} ${addr.isDefault ? "default" : ""}`} key={addr.addressId} onClick={() => this.onSelectMyAddress(addr, addr.addressId)}>
					<div className="wrap-svg">
						{IcAddressType(addr.addressType)}
					</div>
					<div className="wrap-text">
						<p className="address-title">{addr.addressName}</p>
						<p>{getAddressName(addr)}</p>
					</div>
				</div>
			)}
			</div>
			</Modal.Body>
		</Modal>
		)
	}
}	

export { MapDelivery, CustomAddress, ListAddress }


export default class LocationDelivery extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			car: props.car,
			isShowDelivery: props.show,
			isOpenListAddress: false,
			isCustomAddress: false,
			carAddress: {
				address: props.car.locationAddrS,
				location: {
					lat: props.car.location.lat,
					lng: props.car.location.lon
				},
				type: DType.CAR_ADDR
			},
			customAddress: {
				address: "",
				location: null,
				type: DType.CUSTOM_ADDR
			},
			myAddress: {
				address: "",
				location: null,
				type: DType.MY_ADDR
			},
			dAddress: {
				address: "",
				location: null,
				type: null
			},
			airportAddress: {
				address: "",
				location: null,
				type: DType.AIRPORT
			},
			deliveryId: props.deliveryId,
			msgCustom: ""	
		}


	}

	componentDidMount() {
			let { deliveryId } = this.props
			const { car, location, address, type, selfPickup, loggedProfile } = this.props;



			if (type === DType.AIRPORT && car.deliveryLocations && !this.props.deliveryId ) { 
				car.deliveryLocations.map(delivery => { 
				
					if (delivery.name == address && delivery.lat === location.lat && delivery.lon === location.lng) {
						deliveryId = delivery.deliveryId
						this.setState({
							deliveryId: delivery.deliveryId
						})
					}
				})
			}
			
			const data = {
				carId: car.id,
				lat: location.lat,
				lng: location.lng,
				deliveryId: deliveryId
			};


			this.getCarPrice(data);
		
			if (this.isLogged()) {
				this.props.getListAddress();
			} 
		
			if (address === "" || !location ) {
				this.setState({
					dAddress: {
						address: car.locationAddrS,
						location: {
							lat: 0,
							lng: 0
						},
						type: DType.CAR_ADDR
					}
				})
			} 

			this.setState({
				dAddress: {
					address: address,
					location: {
						lat: location.lat,
						lng: location.lng
					},
					type: type
				},
				selfPickup: selfPickup
			})
			
			this.getDAddress(address, location, type)
		}
	
		componentDidUpdate(prevProps) {
			const { myAddress, dAddress, airportAddress } = this.state;
			const { show, listAddress, car, type, address, location } = this.props;

			
			if (prevProps.show !== this.props.show) {
				this.setState({
					isShowDelivery: this.props.show
				})
			}

			if (prevProps.car !== this.props.car) {
				this.setState({
					car,
					carAddress: {
						address: car.locationAddrS,
						location: {
							lat: car.location.lat,
							lng: car.location.lon
						},
						type: DType.CAR_ADDR
					}
				})
			}

			
	
			if (this.isLogged() && listAddress) {
				
				if (prevProps.listAddress !== listAddress) { 
					let extAddress = listAddress.filter(addr => { return myAddress.address !== "" && myAddress.location && addr.lat === myAddress.location.lat && addr.lon === myAddress.location.lng }) 
					
					if (myAddress.address !== "" && extAddress.length < 1 && type !== DType.AIRPORT) {
						this.setState({
							customAddress: {
								address: myAddress.address,
								location: {
									lat: myAddress.location.lat,
									lng: myAddress.location.lng
								}
							},
							// dAddress: {
							// 	address: myAddress.address,
							// 	location: {
							// 		lat: myAddress.location.lat,
							// 		lng: myAddress.location.lng
							// 	},
							// 	type: DType.CUSTOM_ADDR
							// }
						})
					}
	
					if (myAddress.address === "" || (myAddress.address !== "" && extAddress.length < 1)) {

						let defaultAddress = listAddress.length > 0 && listAddress.filter(addr => {
							return addr.isDefault === 1
						});
	
						let address = "";
						let addressLat = 0;
						let addressLng = 0;
			
	
						if (defaultAddress.length > 0) {
							address = getAddressName(defaultAddress[0]);
							addressLat = defaultAddress[0].lat;
							addressLng = defaultAddress[0].lon;
						
						} else {
							address = getAddressName(listAddress[0]);
							addressLat = listAddress[0].lat;
							addressLng = listAddress[0].lon;
						
						}

					
						this.setState({
							myAddress: {
								address,
								location: {
									lat: addressLat,
									lng: addressLng
								},
								type: DType.MY_ADDR
							}
						})
					}
				} 
			}
		
		}

		isLogged = () => {
			return this.props.loggedProfile && this.props.loggedProfile.uid;
		};
	
	
		getCarPrice = (data) => {
				let { carId, lat, lng, deliveryId } = data;	
				const { startDate, endDate } = this.props; 
				const promoCode = null;
				const { carAddress } = this.state;

				if (lat == carAddress.location.lat && lng == carAddress.location.lng ) {
					lat = 0; 
					lng = 0
				}

				getCarPrice(carId, startDate, endDate, lat, lng, promoCode, deliveryId, stypes.SD).then(resp => {
					if (resp.data.error >= commonErr.SUCCESS) {
						this.setState({
							deliveryFee: resp.data.data.car.priceSummary.deliveryFee,
							deliveryDistance: resp.data.data.car.priceSummary.deliveryDistance,
						})
					}
				})
		}
	
		getDAddress = (address, location, type) => {

			const { listAddress } = this.props;


			if (!this.isLogged() && type === DType.MY_ADDR) {
			
				this.setState({
					customAddress: {
						address,
						location,
						type: DType.CUSTOM_ADDR
					},
					dAddress: {
						address,
						location,
						type: DType.CUSTOM_ADDR
					}
				})
				return;
			}
		
			switch (type) {
			
				case DType.CUSTOM_ADDR:
					this.setState({
						customAddress: {
							address,
							location,
							type: DType.CUSTOM_ADDR
						}
					})
					break;
				case DType.MY_ADDR: 
					this.setState({
						myAddress: {
							address,
							location,
							type: DType.MY_ADDR
						}
					})
					break;
				case DType.AIRPORT: 
					this.setState({
						airportAddress: {
							address,
							location, 
							type: DType.AIRPORT
						}
					})
				default:
					return;	
			}
		}

		showCustomAddress = () => {
	
			this.setState({
				isCustomAddress: true,
				isShowDelivery: false
			})
		
		}
		
		closeCustomAddress = () => {
			this.setState({
				isCustomAddress: false,
				isShowDelivery: true
			})	
		}
		
		onUpdateCustomAddress = (address, location) => {
				const { car } = this.state;
				const data = {
					carId: car.id,
					lat: location.lat,
					lng: location.lng,
					deliveryId: undefined
				};
				this.getCarPrice(data);
			
				this.setState({
					customAddress: {
						address,
						location,
						type: DType.CUSTOM_ADDR
					},
					dAddress: {
						address,
						location,
						type: DType.CUSTOM_ADDR
					},
					isDelivery: false,
					deliveryId: undefined
				})
			
				cookie.save("_slfpk", false, { path: '/' })
			
				this.closeCustomAddress()
		}
	
		
	
		
		// onUpdateCustomAddress = (address, location) => {
				
		// 		const { car } = this.state;
		// 		const data = {
		// 			carId: car.id,
		// 			lat: location.lat,
		// 			lng: location.lng,
		// 			deliveryId: undefined
		// 		};
				
		// 		this.getCarPrice(data);
			
		// 		this.setState({
		// 			customAddress: {
		// 				address,
		// 				location,
		// 				type: DType.CUSTOM_ADDR
		// 			},
		// 			dAddress: {
		// 				address,
		// 				location,
		// 				type: DType.CUSTOM_ADDR
		// 			},
		// 			selfPickup: false,
		// 			deliveryId: undefined
		// 		})
			
		// 		cookie.save("_slfpk", false, { path: '/' })
			
				
		// }
	
		showListAddress = () => {
			this.setState({
				isOpenListAddress: true,
				isShowDelivery: false
			})
		}
		
		closeListAddress = () => {
			this.setState({
				isOpenListAddress: false,
				isShowDelivery: true
			})
		}
		
		onSelectMyAddress = (address) => {
			const { car } = this.state;
			const data = {
				carId: car.id,
				lat: address.location.lat,
				lng: address.location.lon,
				deliveryId: undefined
			};
			this.getCarPrice(data); 
		
			this.setState({
				myAddress: {
					address: address.address,
					location: {
						lat: address.location.lat,
						lng: address.location.lon
					},
					type: DType.MY_ADDR
				},
	
				dAddress: {
					address: address.address,
					location: {
						lat: address.location.lat,
						lng: address.location.lon
					},
					type: DType.MY_ADDR
				},
				selfPickup: false,
				deliveryId: undefined
			})	

			cookie.save("_slfpk", false, { path: '/' })

			this.closeListAddress()
		}		

		onSelectPickupAddress = (addressObj, selfPickup) => {
			let { address, location, type } = addressObj;
			const { car, carAddress } = this.state;

			if (addressObj.address == "" || !addressObj.location) {
				this.showCustomAddress()
				return;
			} 

			if (selfPickup) {
	
				const data = {
					carId: car.id,
					lat: carAddress.location.lat,
					lng: carAddress.location.lng,
					deliveryId: undefined
				};
				this.getCarPrice(data);

			} else {
				const data = {
					carId: car.id,
					lat: location.lat,
					lng: location.lng,
					deliveryId: addressObj.deliveryId
				};
				this.getCarPrice(data);
			}

			this.setState({
				dAddress: {
					address: address,
					location: {
						lat: location.lat,
						lng: location.lng
					},
					type: type
				},
				selfPickup: selfPickup,
				deliveryId: addressObj.deliveryId,
				msgCustom: ""
			})

			cookie.save("_slfpk", selfPickup, { path: '/' })
		
		}
	
		onHide = () => {
			const { isShowDelivery } = this.state;
			this.setState({
					err: commonErr.INNIT,
					errMsg: "",
			})
			this.props.onHide(isShowDelivery)
		}
		
		isValidAddress = () => {
			const { location } = this.state.dAddress;
			const { deliveryFee } = this.state;
			return deliveryFee > -1 && location && location.lat && location.lat !== 0 && location.lng && location.lng !== 0;
		}
		
		onUpdate = () => {
			const { selfPickup, dAddress, isShowDelivery, deliveryId } = this.state;
			const { address, location, type } = dAddress;

			this.props.onUpdate(address, location, type, selfPickup, deliveryId);
			this.props.onHide(isShowDelivery);
	 	}
	
		render() {
			const { err, errMsg, isShowDelivery, car, deliveryFee, deliveryDistance, isOpenListAddress, dAddress, customAddress, myAddress, carAddress, selfPickup, airportAddress, msgCustom, isCustomAddress} = this.state;	
			const { listAddress } = this.props;
			let airport = {};

			if (car.deliveryLocations) {
				
				airport = {
					address: car.deliveryLocations[0].name, 
					location: {
						lat: car.deliveryLocations[0].lat,
						lng: car.deliveryLocations[0].lon
					},
					type: DType.AIRPORT,
					deliveryFee: car.deliveryLocations[0].deliveryFee,
					deliveryId: car.deliveryLocations[0].deliveryId
				}
			
			
			}
			
			return (<>
				<Modal
				show={isShowDelivery}
				onHide={this.onHide}
				dialogClassName="modal-l modal-dialog modal-delivery-location">
					<Modal.Header closeButton={true} closeLabel={""}>
						<h5>Địa điểm giao nhận xe</h5>
					</Modal.Header>
					<Modal.Body>
					<div className="delivery-location">
							<div className="map-deli">
								
								{dAddress.location && <MapDelivery dAddress={dAddress} carAddress={carAddress} /> }
								
								<div className="delivery"> 
									<div className="title"> 
									<p className="main">Giao xe nhận xe tận nơi</p>
									<p className="note">Chủ xe sẽ giao và nhận xe đến tận nhà hoặc địa chỉ mà bạn lựa chọn trên ứng dụng Mioto</p>
									</div>
									<div className="content"> 
										<div className="item"> 
											<p>Giao nhận xe tận nơi trong</p>
											<p className="main">{car.deliveryRadius} km</p>
										</div>
										
										{(car.deliveryRadiusFree > 0 && (car.deliveryRadiusFree !== car.delieveryRadius)) &&<div className="item"> 
											<p>Miễn phí giao nhận trong</p>
											<p className="main">{car.deliveryRadiusFree} km</p>
										</div>}
										<div className="item"> 
											<p>Phí giao nhận xe (2 chiều)</p>
											<p className="main"><NumberFormat value={car.deliveryPrice} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ/km"} /></p>
										</div>
									</div>
								</div>
							</div>
							<div className="address-pick">
							<div className={`address-pick__item ${carAddress.address === dAddress.address ? 'active' : ''}`}  onClick={() => this.onSelectPickupAddress(carAddress, true)}>
									<div className="custom-radio"> 
										<input type="radio" id="r_carAddress" name="addr_pickup" checked={carAddress.address === dAddress.address} />
										<label htmlFor="r_carAddress">Nhận xe tại vị trí xe
											<div className="label-container"> 
											<div className="address">
												<div className="wrap-svg">
													<IcListCar />
												</div>
												<p>{carAddress.address}</p>
											</div>
											<p className="note">Bạn sẽ nhận và trả xe tại vị trí xe (địa chỉ cụ thể sẽ được hiển thị sau khi đặt cọc)</p>
											</div>
										</label>
									</div>
								</div>

								<div className={`address-pick__item ${customAddress.address == dAddress.address ? 'active' : ''}`}> 
									<div className="custom-radio"> 
										<input type="radio" id="r_pickMap" name="addr_pickup" checked={customAddress.address === dAddress.address} onChange={() => this.onSelectPickupAddress(customAddress, false)} />
										<label htmlFor="r_pickMap">Chọn từ bản đồ
											<div className="label-container"> 
												<div className="address input" onClick={this.showCustomAddress}>
													<div className="wrap-svg">
														<IcLocationLine />
													</div>
													<p>{customAddress.address !== "" ? customAddress.address : "Chọn địa chỉ giao nhận xe"}</p>	
												</div> 
												
												{customAddress.address == dAddress.address && <>
													{deliveryFee > 0 ? 
														<p className="note text-success">Tổng phí giao nhận xe (2 chiều) là <NumberFormat value={deliveryFee} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={' đ'} /> cho quãng đường {deliveryDistance} km</p> 
														: 
														deliveryFee == 0 ? 
														<p className="note text-success">Tổng phí giao nhận xe (2 chiều) là <NumberFormat value={deliveryFee} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={' đ'} /> cho quãng đường {deliveryDistance} km</p> 
														: 
														<p className="note text-danger">Địa điểm giao nhận quá xa so với vị trí của xe ({deliveryDistance} km). Bạn vui lòng chọn địa điểm giao nhận gần hơn hoặc có thể chọn thuê xe khác.</p>
													} 
												</>}
											</div>
										</label>
									</div>
									{customAddress.address !== "" && <a className="btn btn-link font-12" onClick={this.showCustomAddress} >Thay đổi</a>}

									 
								</div>
								{car.deliveryLocations && airport && <div className={`address-pick__item ${airport.address == dAddress.address ? 'active' : ''}`} onClick={() => this.onSelectPickupAddress(airport, false)}> 
									<div className="custom-radio"> 
									<input type="radio" id="r_airport" name="addr_pickup" checked={airport.address === dAddress.address} />
									<label htmlFor="r_airport">Giao xe sân bay
										<div className="label-container"> 
											<div className="address">
												<div className="wrap-svg">
													<IcPlane />
												</div>
												<p>{airport.address}</p>
												
											</div>
											{airport.address == dAddress.address && <>
												{airport.deliveryFee === 0 ? 
												<p className="note text-success">Miễn phí giao nhận xe (2 chiều) cho quãng đường {deliveryDistance} km </p> :
												airport.deliveryFee > 0 ? 
												<p className="note text-success">Tổng phí giao nhận xe (2 chiều) là <NumberFormat value={airport.deliveryFee} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={' đ'} /> cho quãng đường {deliveryDistance} km</p> :
												<p className="note text-danger">Địa điểm giao nhận quá xa so với vị trí của xe ({deliveryDistance} km). Bạn vui lòng chọn địa điểm giao nhận gần hơn hoặc có thể chọn thuê xe khác.</p>}
											</>}
										</div>
									</label>
									</div>
								</div>}
								{this.isLogged() && myAddress.address && myAddress.address !== '' && <div className={`address-pick__item ${myAddress.address === dAddress.address ? 'active' : ''}`} > 
									<div className="custom-radio" > 
										<input type="radio" id="r_myAddress" name="addr_pickup" checked={myAddress.address === dAddress.address} onChange={() => this.onSelectPickupAddress(myAddress, false)} />
										<label htmlFor="r_myAddress">Địa chỉ của tôi
											<div className="label-container"> 
											<div className="address">
												<div className="wrap-svg">
													<IcUser />
												</div>
												<p>{myAddress.address} </p>
											</div>
											{msgCustom !== '' && <p className="note text-danger">{msgCustom}</p>}
											{myAddress.address === dAddress.address && <>
												{deliveryFee > 0 ? 
													<p className="note text-success">Tổng phí giao nhận xe (2 chiều) là <NumberFormat value={deliveryFee} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={' đ'} /> cho quãng đường {deliveryDistance} km</p> 
													: 
												deliveryFee == 0 ? 
													<p className="note text-success">Miễn phí giao nhận xe (2 chiều) cho quãng đường {deliveryDistance} km</p> 
													: 
													<p className="note text-danger">Địa điểm giao nhận quá xa so với vị trí của xe ({deliveryDistance} km). Bạn vui lòng chọn địa điểm giao nhận gần hơn hoặc có thể chọn thuê xe khác.</p>}
												</>
											} 
											</div>
										</label>
									</div>
									{listAddress && listAddress.length > 1 && <a className="btn btn-link font-12" onClick={() => this.showListAddress()} >Thay đổi</a>}
								</div>}

								<a disabled={!dAddress.address || !this.isValidAddress()} onClick={this.onUpdate} className="btn btn-primary btn--m" >Thay đổi</a>
								
								</div>
								
							</div>
							
            	</Modal.Body>
				</Modal>
				{listAddress && listAddress.length > 0 && <ListAddress
					activeAddress={myAddress}
					listAddress={listAddress}
					show={isOpenListAddress}
					onHide={this.closeListAddress}
					onSelectMyAddress={this.onSelectMyAddress} />}
				<CustomAddress
					show={isCustomAddress}
					onHide={this.closeCustomAddress}
					stype={stypes.SD}
					address={customAddress.address}
					location={customAddress.location}
					onUpdate={this.onUpdateCustomAddress}
					deliveryFee={deliveryFee}
					deliveryDistance={deliveryDistance}
					dAddress={dAddress.address}
					msgCustom={msgCustom}
				/>
				
				</>
				
			
		 )
    }
}

